import builtinRoles from "./roles.json";
import builtinFabled from "./fabled.json";
import { usesScriptFabledImage } from "./fabledRole";
import { imageNameKey, imageWithFallback } from "./imageFallback";

const builtin = [...builtinRoles, ...builtinFabled];
const builtinByName = new Map(builtin.map(role => [imageNameKey(role.name), role]));
const builtinById = new Map(builtin.map(role => [role.id, role]));
const TEAM_ICONS = {
  townsfolk: "good", outsider: "outsider", minion: "minion",
  demon: "evil", fabled: "fabled"
};
const builtInIcon = name => {
  if (!name) return "";
  try { return require("./assets/icons/" + name + ".png"); }
  catch (error) { return ""; }
};
const sameNameIcon = item => {
  const key = imageNameKey(item.name);
  const role = key && builtinByName.get(key);
  return role ? builtInIcon(role.imageAlt || role.id) : "";
};
const placeholder = item => builtInIcon(TEAM_ICONS[item.team] || "custom");
const fromImage = (source, item) => imageWithFallback(
  source, sameNameIcon(item), placeholder(item), builtInIcon("custom")
);

// 原图/自定义图片偏好保持原规则；选中的图片失败后按名称精确回退。
// 只返回显示地址，绝不替换JSON的技能、图片字段或实际阵营。
export const roleIconSource = (role, options = {}) => {
  const item = role || {};
  if (item.image && (item.isAdmin || usesScriptFabledImage(item) || options.isImageOptIn)) {
    return fromImage(item.image, item);
  }
  const local = [item.imageAlt, item.iconId, item.id].map(builtInIcon).find(Boolean);
  return local
    ? imageWithFallback(local, sameNameIcon(item), placeholder(item), builtInIcon("custom"))
    : fromImage(item.image, item);
};

// Token原有imageAlt/id优先级不变；头像另走头像链，失败不能披露角色。
export const tokenIconSource = (role = {}, options = {}) => {
  if (role.isAdmin || usesScriptFabledImage(role) || (role.image && options.isImageOptIn)) {
    return roleIconSource(role, options);
  }
  const local = builtInIcon(role.imageAlt || role.id);
  return local
    ? imageWithFallback(local, sameNameIcon(role), placeholder(role), builtInIcon("custom"))
    : fromImage(role.image, role);
};
export const snapshotRoleIconSource = (role = {}, options = {}) =>
  role.snapshotImage ? fromImage(role.snapshotImage, role) : tokenIconSource(role, options);

export const reminderIconSource = (item = {}, options = {}) => {
  // 标记name是提示文字，不是角色名；从公开定义/已冻结roleName取得所属角色名。
  const owner = options.roles?.get(item.role) || builtinById.get(item.role);
  const named = { ...item, name: item.roleName || owner?.name || item.name };
  const local = builtInIcon(item.imageAlt || item.role);
  const primary = options.useSnapshot && item.snapshotImage
    ? item.snapshotImage
    : (item.image && options.isImageOptIn ? item.image : local || item.image);
  return imageWithFallback(primary, sameNameIcon(named), local, builtInIcon("custom"));
};

export default roleIconSource;
